module.exports = __webpack_public_path__ + "media/assets/images/bg-accesstodashboard-4d7716a58d63a3ad505c5c8ed4c8adf3.png";